import { render, staticRenderFns } from "./TetraRadioGroupSelect.vue?vue&type=template&id=35bdf514&scoped=true&lang=pug&"
import script from "./TetraRadioGroupSelect.vue?vue&type=script&lang=js&"
export * from "./TetraRadioGroupSelect.vue?vue&type=script&lang=js&"
import style0 from "./TetraRadioGroupSelect.vue?vue&type=style&index=0&id=35bdf514&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bdf514",
  null
  
)

export default component.exports